import React from 'react';
import styled, { keyframes } from 'styled-components';
import closeIcon from '../../asset/img/common/close_icon2.svg';
import speaker from '../../asset/img/common/speaker_icon.svg';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DialogContainer = styled.div`
  background-color: white;
  border-radius: 16px;
  width: calc(100% - 32px);
  max-width: 360px;
  animation: ${fadeIn} 0.2s ease-out;
  z-index: 1003;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);

  padding: 16px 16px 48px 16px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 16px;
  .title {
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }
  .description {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    white-space: pre-wrap;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`;

const CloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const InputPeriodEndAlert = ({
  isOpen,
  isTargetDate,
  onClose,
  // title = '입력기간이 종료되었습니다',
  // description = '추가 · 수정 · 삭제할 내용이 있는 경우, 추가서류 접수기간에 신청해주시기 바랍니다.',
}) => {
  if (!isOpen) return null;

  const title = isTargetDate
    ? '연말정산 서비스 오픈을 준비하고 있어요'
    : '입력기간이 종료되었습니다.';
  const description = isTargetDate
    ? '현재 연말정산 서비스 오픈을 준비하고 있습니다.\r\n서비스가 시작되면 이 화면을 통해 바로 이용하실 수 있습니다.\r\n구체적인 일정은 홈화면의 연말정산 일정을 참고해주세요.\r\n잠시만 기다려 주시면 감사하겠습니다. '
    : '입력기간이 종료되었습니다.\r\n추가 · 수정 · 삭제할 내용이 있는 경우, 추가서류 접수기간에 신청해주시기 바랍니다.';

  return (
    <Overlay onClick={onClose}>
      <DialogContainer onClick={e => e.stopPropagation()}>
        <CloseIcon onClick={onClose}>
          <img src={closeIcon} alt="닫기" />
        </CloseIcon>
        <Title>
          <div>
            <img
              style={{ width: '24px' }}
              src={speaker}
              alt="입력기간이 종료되었습니다  추가 · 수정 · 삭제할 내용이 있는 경우, 추가서류 접수기간에 신청해주시기 바랍니다."
            />
          </div>
          <div className="subtitleBold">{title}</div>
          <div
            className="body2Medium"
            style={{ whiteSpace: 'pre-wrap', textAlign: 'left', padding: '0 16px' }}>
            {description}
          </div>
        </Title>
      </DialogContainer>
    </Overlay>
  );
};

export default InputPeriodEndAlert;
